<template>
  <div class="categories-with-products">
    <div class="categories-with-products__title">{{ title }}</div>
    <div class="categories-with-products__categories">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="swiper-item" v-for="category in items" :key="category.id">
          <div :class="{ 'active': selectedCategory.id === category.id }"
               class="categories-with-products__category"
               @click="selectCategory(category)"
          >{{ category.name }}</div>
        </swiper-slide>
      </swiper>
      <div class="categories-with-products__categories-navigation">
        <div class="swiper-button-prev categories-slider-arrow--prev" slot="button-prev"></div>
        <div class="swiper-button-next categories-slider-arrow--next" slot="button-next"></div>
      </div>
    </div>
    <div class="categories-with-products__products-wrap">
      <div class="categories-with-products__category-img-wrap">
        <img :src="isMobile ? selectedCategory.image_mob : selectedCategory.image" v-if="selectedCategory.image || selectedCategory.image_mob" alt="">
        <div class="categories-with-products__category-img-wrap-title">{{ selectedCategory.name }}</div>
      </div>
      <div class="categories-with-products__products-slider" v-if="selectedCategory.products && selectedCategory.products.length">
        <div class="swiper-button-prev products-slider-arrow products-slider-arrow--prev" slot="button-prev"></div>
        <swiper ref="productsSlider" class="swiper" :options="swiperOption2">
          <swiper-slide class="swiper-item" v-for="product in selectedCategory.products" :key="product.id">
            <ProductCardSimpleBig
              @onIntersecting="collectAnalyticsData($event)"
              :product="product"
            ></ProductCardSimpleBig>
          </swiper-slide>
        </swiper>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
        <div class="swiper-button-next products-slider-arrow products-slider-arrow--next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCardSimpleBig from '@/components/product/product-card/ProductCardSimpleBig.vue'
import { mapGetters } from 'vuex'
import { isTouch } from '@/mixins/isTouchDevice'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'CategoriesWithProducts',
  components: { Swiper, SwiperSlide, ProductCardSimpleBig },
  data () {
    return {
      collectedAnalyticsData: [],
      swiperOption: {
        watchSlidesVisibility: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.categories-slider-arrow--next',
          prevEl: '.categories-slider-arrow--prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false
      },
      swiperOption2: {
        observer: true,
        watchSlidesVisibility: true,
        spaceBetween: 10,
        slidesPerView: 1.3,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false
        },
        navigation: {
          nextEl: '.products-slider-arrow--next',
          prevEl: '.products-slider-arrow--prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          601: {
            spaceBetween: 10,
            slidesPerView: 2
          },
          769: {
            spaceBetween: 10,
            slidesPerView: 3
          }
        }
      },
      windowWidth: window.innerWidth,
      selectedCategory: {}
    }
  },
  mixins: [isTouch],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isUkLanguage']),
    title () {
      return this.data[`title_${this.isUkLanguage ? 'uk' : 'ru'}`]
    },
    items () {
      return this.data.data
    },
    isMobile () {
      return this.windowWidth < 768
    }
  },
  methods: {
    selectCategory (category) {
      this.selectedCategory = category
    },
    collectAnalyticsData (el) {
      this.collectedAnalyticsData.push(el)
    },
    async sendAnalyticsData () {
      if (this.collectedAnalyticsData.length) {
        if (GoogleEnhancedEcommerce.isEnabled) {
          if (this.collectedAnalyticsData.length) {
            await GoogleEnhancedEcommerce.viewItemList({
              analyticsData: this.collectedAnalyticsData,
              listId: 'блок категорій з товарами',
              listName: this.data.title_uk
            })
            this.collectedAnalyticsData = []
          }
        }
      }
    }
  },
  mounted () {
    if (this.items) {
      this.selectedCategory = this.items[0]
    }
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  watch: {
    collectedAnalyticsData () {
      setTimeout(() => {
        this.sendAnalyticsData()
      }, 1000)
    }
  }
}
</script>
<style lang="sass">
.categories-with-products__product-btn-wrap
  .buy-btn
    color: $text-color
    background-color: $page-bg
    &:hover,
    &:focus
      color: $white-text-color
      background-color: $main-color
    +mbetween($large, $large--ext)
      padding: 10px 15px
    +mbetween($tablet--hor, $large)
      padding: 10px
    +mbetween($tablet, $tablet--hor)
      padding: 10px
  .add-to-cart__svg-wrap
    display: none
</style>
<style lang="sass" scoped>
@import "../../../node_modules/swiper/css/swiper.min.css"
@import "../../styles/swiper/swiper"
.products-slider-arrow
  width: 60px
  height: 100%
  flex-shrink: 0
  background: #fff
  top: 0
  transform: none
  margin: 0
  +mmax($large--ext)
    width: 40px
  +mmax($small)
    display: none
  &:after, &:before
    font-size: 20px
  &--prev
    left: -75px
    +mmax($large--ext)
      left: -45px
  &--next
    right: -75px
    +mmax($large--ext)
      right: -45px
.categories-with-products
  padding: 52px 50px
  border-radius: 5px
  background: #F8F8F8
  margin: 0 -30px
  +mmax($tablet--hor)
    padding: 40px 15px
    border-radius: 0
    margin: 0
  .swiper-scrollbar-drag
    background: #FF2F00
  .swiper-scrollbar
    display: none
    margin-top: 25px
    height: 7px
    +mmax($small)
      display: block
  &__products
    &-wrap
      display: flex
      +mmax($tablet--hor)
        flex-direction: column
    &-slider
      display: flex
      align-items: stretch
      position: relative
      margin: 0 75px 0 95px
      width: calc(77% - 160px)
      +mmax($large--ext)
        margin: 0 45px 0 55px
        width: calc(77% - 100px)
      +mmax($tablet--hor)
        margin: 0 45px
        width: calc(100% - 90px)
      +mmax($small)
        margin: 0
        width: 100%
        flex-direction: column
      .swiper-container
        width: 100%
        align-items: stretch
  &__title
    color: #2E2E2E
    font-size: 24px
    font-style: normal
    font-weight: 500
    line-height: normal
    margin-bottom: 30px
  &__categories
    display: flex
    align-items: center
    position: relative
    margin-bottom: 50px
    +mmax($large--ext)
      margin-bottom: 22px
    &:after
      content: ''
      background: rgba(51, 51, 51, 0.20)
      width: 100%
      height: 1px
      position: absolute
      left: 0
      top: calc(100% - 2.5px)
    .swiper-container
      margin-left: 0
    &-navigation
      position: relative
      width: 70px
      flex-shrink: 0
      margin-left: 35px
      display: block
      +mmax($tablet)
        display: none
    .swiper-slide
      width: fit-content
      &:first-child
        .categories-with-products__category
          padding-left: 0
  &__category
    color: #909090
    font-size: 18px
    font-style: normal
    font-weight: 400
    line-height: normal
    padding: 15px 35px 20px
    position: relative
    cursor: pointer
    white-space: nowrap
    &.active
      &:after
        background: #FF2F00
    &:after
      content: ''
      position: absolute
      left: 0
      top: calc(100% - 5px)
      height: 5px
      width: 100%
      border-radius: 3px
      background: transparent
      transition: background 0.2s
    &-img-wrap
      width: 23%
      flex-shrink: 0
      padding-top: 28%
      position: relative
      background-color: #333333
      border-radius: 8px
      overflow: hidden
      +mmax($large--ext)
        padding-top: 31%
      +mmax($tablet--hor)
        width: 100%
        margin-bottom: 22px
      &:after
        content: ''
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        background: linear-gradient(186deg, rgba(51, 51, 51, 0.00) 45.6%, #333 97.38%)
        z-index: 1
      &-title
        position: absolute
        left: 0
        bottom: 0
        width: 100%
        padding: 35px 25px
        color: #FFF
        font-size: 30px
        font-style: normal
        font-weight: 500
        z-index: 2
        +mbetween($tablet--hor, $large)
          padding: 15px 15px
          font-size: 20px
        +mbetween($tablet--hor, $small)
          padding: 15px 40px
          font-size: 24px
        +mmax($small)
          padding: 15px 15px
          font-size: 20px
      img
        width: 100%
        position: absolute
        object-fit: cover
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        width: 100%
        height: 100%

</style>
